import { COLOR, line, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'DONCHIAN',
  version: 1,
  label: 'Donchian Channels',
  pane: 'main',
  category: 'trend',
  series: 'price',
  order: 42,
  inputs: [period('timeperiod', 20)],
  outputs: [line('upper', 'Upper', COLOR.teal), line('basis', 'Basis', COLOR.orange), line('lower', 'Lower', COLOR.teal)],
  talib: {
    functions: ['MAX', 'MIN'],
    expr: {
      upper: 'MAX(high, timeperiod={timeperiod})',
      basis: '(MAX(high, timeperiod={timeperiod}) + MIN(low, timeperiod={timeperiod})) / 2',
      lower: 'MIN(low, timeperiod={timeperiod})',
    },
  },
  listed: true,
  tailSafe: true,
  lookback: ({ timeperiod }) => timeperiod - 1,
}
export default def
